<template>
    <slot></slot>
</template>